<template>
    <slot></slot>
</template>